import axios from "axios";
import axiosInstance from "../../axiosinterceptor";

export const navigationTree = async ( ) => {
  const userId = sessionStorage.getItem("userId"); // Retrieve inside the function
  // console.log("Retrieved userId from sessionStorage:", userId)
    const url =
      "/home_navigation_update_acs";
      // console.log("User ID being passed:", userId); // Log the user_id
      
    try {
      const response = await axiosInstance.post(url,{
        // params: { userId }
        user_id: userId,
      });
      // console.log(response,'pp');
      return response.data;
    } catch (error) {
      console.log(error)
    }

  };